import { IconArrowLeft } from '@tabler/icons-react';
import { PageIntro } from '@/components/rides/PageIntro';
import { LegalDocument } from '@/components/ui';
import { useSafeBack } from '@/components/shell/useSafeBack';
import { DEFAULT_PRIVACY_NOTICE_HTML } from '@/lib/copy';
import { stripUnsafeHtml } from '@/lib/sanitize';
import { useCopy, contactVars, fillPlaceholders } from '@/lib/settings';

/** Privacy notice: a short plain-language summary, a contents list, then the full POPIA notice. */
export default function PrivacyPage() {
  const back = useSafeBack();
  const { t, settings } = useCopy();
  const raw = settings.privacyNoticeHtml?.trim() || DEFAULT_PRIVACY_NOTICE_HTML;
  // The API fills {deleteDataEmail}/{supportEmail}; fill again client-side in case it did not.
  const html = stripUnsafeHtml(fillPlaceholders(raw, contactVars(settings, t('app.name'))));
  return (
    <div className="rides-main">
      <button type="button" className="rides-backlink" onClick={back}><IconArrowLeft size={20} aria-hidden="true" /> Back</button>
      <PageIntro title="Privacy notice" lede={t('privacy.intro')} />
      <LegalDocument html={html} summary={t('privacy.summary').split('\n')} />
    </div>
  );
}
